/**
 * Flavour text rotated on the card-drop gathering screen (card-drop v2). Themed
 * around shuffling, the thinning odds, and the 4.5s sweet-spot pull — distinct
 * from AOTD's `loadingMessages.ts` so the two waiting states never feel the same.
 */
export const CARD_DROP_LOADING_MESSAGES: readonly string[] = [
  "Shuffling the deck…",
  "Counting who showed up…",
  "The odds are thinning…",
  "Someone always pulls at 4.5 seconds…",
  "Splitting the pot between latecomers…",
  "Cutting the deck twice, just to be safe…",
  "Every new arrival steals a sliver of your luck…",
  "Greasing the dealer's palms…",
  "Measuring everyone's nerve…",
  "The pool is finite — choose your moment…",
  "Stacking the legendaries near the top. Allegedly…",
  "Tightening the felt on the table…",
  "Watching the room fill up (and your chances drop)…",
  "Calibrating the 4.5-second sweet spot…",
  "Dealing whispers and bluffs…",
  "Hoping nobody else read the strategy guide…",
  "Reshuffling because someone sneezed…",
  "Reminding the RNG who's boss…",
  "Counting cards (we won't tell)…",
  "Holding the drop until the suspense peaks…",
  "Warming up the reveal machine…",
  "Letting the latecomers sweat a little…",
];
